var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('Navbar'),_c('Section',{attrs:{"title":"How BEX works?","small-text":"Learn how to start selling on BEX in 6 different steps","component-name":"HowWorksContent"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }